/* eslint-disable */
import _ from 'lodash';

// Sections are user-defined grouping LABELS (not a DB entity). `sections` is the
// ordered label list; each table carries its label in `table.section`. Tables are
// flat; on save the backend derives grouping from each table's `section` string.

let keySeq = 0;
const nextKey = () => {
	keySeq += 1;
	return `k${keySeq}`;
};

const fromApi = (floor) => {
	const tables = (floor?.tables || []).map((t) => ({
		_key: nextKey(),
		id: t.id ?? null,
		section: t.section || '',
		name: t.name || '',
		capacity: t.capacity ?? 2,
		isEnabled: t.isEnabled !== false,
		occupied: !!t.occupied,
	}));
	const sections = [];
	tables.forEach((t) => {
		const s = t.section || '';
		if (s && !sections.includes(s)) sections.push(s);
	});
	return { sections, tables };
};

const toPayload = (state) => ({
	tables: (state.tables || []).map((t) => ({
		...(t.id ? { id: t.id } : {}),
		section: t.section || null,
		name: (t.name || '').trim(),
		capacity: Number(t.capacity) || 0,
		isEnabled: !!t.isEnabled,
		occupied: !!t.occupied,
	})),
});

const initialState = { sections: [], tables: [] };

function floorReducer(state, action) {
	switch (action.type) {
		case 'INIT':
			return fromApi(action.payload);
		case 'RESET':
			return { sections: [], tables: [] };

		case 'ADD_SECTION': {
			const name = (action.name || '').trim();
			if (!name || (state.sections || []).includes(name)) return state;
			return { ...state, sections: [...(state.sections || []), name] };
		}
		case 'RENAME_SECTION': {
			const to = (action.to || '').trim();
			if (!to) return state;
			return {
				...state,
				sections: (state.sections || []).map((s) => (s === action.from ? to : s)),
				tables: (state.tables || []).map((t) =>
					t.section === action.from ? { ...t, section: to } : t
				),
			};
		}
		case 'REMOVE_SECTION':
			return {
				...state,
				sections: (state.sections || []).filter((s) => s !== action.name),
				tables: (state.tables || []).filter((t) => (t.section || '') !== action.name),
			};

		case 'ADD_TABLE':
			return {
				...state,
				tables: [
					...state.tables,
					{
						_key: nextKey(),
						id: null,
						section: action.section || '',
						name: action.name || '',
						capacity: action.capacity ?? 2,
						isEnabled: true,
						occupied: false,
					},
				],
			};
		case 'UPDATE_TABLE': {
			const patch = action.patch || { [action.key]: action.value };
			return {
				...state,
				tables: state.tables.map((t, i) =>
					i === action.tableIndex ? { ...t, ...patch } : t
				),
			};
		}
		case 'REMOVE_TABLE':
			return {
				...state,
				tables: state.tables.filter((_, i) => i !== action.tableIndex),
			};

		default:
			return state;
	}
}

const RetailFloorConfig = { initialState, fromApi, toPayload };

export { floorReducer };
export default RetailFloorConfig;
